interface Stat {
  label: string;
  value: string;
}

const stats: Stat[] = [
  { label: 'Products built in-house', value: '2' },
  { label: 'Core focus', value: 'Web & App Dev' },
  { label: 'Client data privacy', value: 'Always' },
];

function About() {
  return (
    <section id="about" className="py-[88px]">
      <div className="wrap grid grid-cols-1 items-center gap-12 min-[861px]:grid-cols-[1.3fr_1fr]">
        <div>
          <p className="eyebrow">About Us</p>
          <h2>Venus Solutions Pvt Ltd</h2>
          <p className="section-lead">
            We&apos;re a software company that partners with businesses to build the
            websites, apps, and tools they run on — and we build our own products, like
            Invyntra, for problems we understand firsthand. Every engagement gets the same
            approach: understand the business first, then design and build software that
            actually fits how it works.
          </p>
        </div>
        <div className="grid gap-4">
          {stats.map((stat) => (
            <div key={stat.label} className="card flex flex-col px-6 py-5">
              <span className="text-[1.6rem] font-bold text-navy">{stat.value}</span>
              <span className="text-[0.9rem] text-muted">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default About;
